import React, { Component } from 'react';
import {AppBarMobile} from "admin-on-rest";
import DevicesList from "../../common/components/DevicesList/DevicesList";
import {appTitle, DESKTOP_VIEW} from "../../util/util";

class Dashboard extends Component {
  
  render() {
    
    return(
      <div>
        {DESKTOP_VIEW || (<AppBarMobile title={appTitle()} />)}
        <DevicesList />
      </div>
    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.js